import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJournaling = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.5172 15.8213C1.4163 13.8924 1.74791 11.9655 2.48777 10.1813C3.22762 8.39717 4.357 6.80101 5.79327 5.50962C7.22954 4.21823 8.93636 3.26429 10.7888 2.71759C12.6413 2.1709 14.5926 2.04528 16.4999 2.34994C16.2102 4.13488 15.527 5.83302 14.4999 7.32127H11.4999C11.4999 7.32127 11.8592 8.12127 12.4772 9.54061C11.0394 10.8474 9.32605 11.8139 7.46406 12.3688C5.60206 12.9236 3.6391 13.0525 1.72054 12.7459",
		stroke: "#D9DEEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgJournaling);
export default ForwardRef;
